import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';

import { Observable } from 'rxjs/Observable';

import { DateUtil } from '../../common-app/util/date-util';
import { SharedService } from '../../common-app/service/shared.service';

import { Constants } from '../../constants/constants';
import { Kvaw0400Service } from '../../service/kvaw0400.service';
import { Kvaw0400Vo, StoreModel, WeekModel } from '../../service/kvaw0400.vo';
import { StoreViewModel, WeekViewModel } from '../kvap0300/kvap0300.view-model';

@Component({
  templateUrl: './kvap0301.component.html',
  providers: [Kvaw0400Service],
})
export class Kvap0301Component implements OnInit {

  public weeks: WeekViewModel[] = [];
  public stores: StoreViewModel[] = [];

  public storesForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private sharedService: SharedService,
    private kvaw0400Service: Kvaw0400Service,
    private router: Router,
  ) { }

  ngOnInit() {

    const selectedWeek = this.sharedService.get<string>(Constants.SHARED_DATA_KEY_SELECTED_WEEK) || '';

    // フォームを初期化する
    this.storesForm = this.formBuilder.group({
      searchWeek: this.formBuilder.control(selectedWeek)
    });

    this.searchStoresObservable(selectedWeek).subscribe(() => {
      // 初期表示がない場合
      if (this.storesForm.controls.searchWeek.value === '' && this.weeks.length !== 0) {
        this.storesForm.controls.searchWeek.setValue(this.weeks[0].startDateFull);
        this.sharedService.set(Constants.SHARED_DATA_KEY_SELECTED_WEEK, this.weeks[0].startDateFull);
      } else {
        this.sharedService.set(Constants.SHARED_DATA_KEY_SELECTED_WEEK, this.storesForm.controls.searchWeek.value);
      }
    });
  }

  /**
   * 担当店一覧を検索する。
   */
  searchStoresObservable(startDate: string = ''): Observable<Kvaw0400Vo> {

    let endDate = '';
    if (startDate) {
      const date = DateUtil.parseYYYYMMDD(startDate);
      date.setDate(date.getDate() + 6);
      endDate = DateUtil.formatYYYYMMDD(date);
    }

    return this.kvaw0400Service.searchStores(startDate, endDate).map(storeList => {

      this.stores = storeList.stores.map(store => {
        return <StoreViewModel>{
          storeCode: store.storeCode,
          storeName: store.storeName,
          deliveryDate: store.deliveryDate,
        };
      });

      return storeList;
    });
  }

  /**
   * 日報報告モードに遷移する。
   */
  goReport() {
    this.router.navigate(['/kvap0302/kvap0300'], { skipLocationChange: true });
  }

  /**
   * 過去日報一覧画面に遷移する。
   * @param store 担当店ViewModel
   */
  navigateToOldReportList(store: StoreViewModel) {
    this.router.navigate(['/kvap0600'], {
      queryParams: {
        storeCode: store.storeCode,
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/component/kvap0301/kvap0301.component.ts